import gql from 'graphql-tag'

export default gql`mutation ycmdContactDelete($custom_contact_id: ID) {
	ycmdContactDelete(custom_contact_id: $custom_contact_id) {
		status
	}
}`
